module.exports = __webpack_public_path__ + "img/aed-cover.5353beec.jpg";